define('AwaLabs.ProductListDetailsLaterFix', [
    'ProductListDetailsLaterFix.ProductList.DetailsLater'
], function ProductListDetailsLaterFix() {
    'use strict';
});
